// DAY-DIRECTSTAFF-2026-10-24 §4: a candidate whose email field holds a placeholder (no "@") or nothing shows "No email on file" and
// an "Add email" field instead of the placeholder; saving writes a real address in its place (updateCandidate). A usable address
// shows as before. lib/emailUsable.js holds the rule (something@something.tld -- the agents' rule since 10-24 too).
import React, { useState } from 'react';
import { usableEmail } from './lib/emailUsable';

const field = { minHeight: 44, fontSize: 13, padding: '0 8px', border: '1px solid #cbd5e1', borderRadius: 8, minWidth: 0, flex: '1 1 160px', boxSizing: 'border-box' };
const btn = (off) => ({ background: '#1d4ed8', color: 'white', border: 0, borderRadius: 8, padding: '0 14px', minHeight: 44, fontSize: 13, fontWeight: 700, cursor: off ? 'not-allowed' : 'pointer', opacity: off ? 0.5 : 1 });

/** candidate; save(email) -> Promise (throws plain words); toast */
export default function CandidateEmail({ candidate, save, toast = () => {} }) {
  const [v, setV] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const has = usableEmail(candidate.email);
  if (has) return <span data-testid="cand-email-value" style={{ fontSize: 12, color: '#0f172a', fontWeight: 500, overflowWrap: 'anywhere' }}>{candidate.email}</span>;
  const go = async (e) => {
    e.preventDefault();
    const clean = usableEmail(v);
    if (!clean) { setErr('Type a full address, like name@example.com.'); return; }
    setBusy(true); setErr('');
    try { await save(clean); toast('Email saved'); setV(''); } catch (x) { setErr(x.message || 'Not saved'); } finally { setBusy(false); }
  };
  return (
    <form data-testid="cand-email-add" onSubmit={go} style={{ display: 'grid', gap: 4, justifyItems: 'end', minWidth: 0, flex: 1 }}>
      <span data-testid="cand-email-none" style={{ fontSize: 12, color: '#92400e', fontWeight: 700 }}>No email on file</span>
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', width: '100%', justifyContent: 'flex-end' }}>
        <label htmlFor={`cand-email-input-${candidate.id}`} style={{ position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0 0 0 0)' }}>Add email</label>
        <input id={`cand-email-input-${candidate.id}`} data-testid="cand-email-input" type="email" inputMode="email" autoComplete="off" placeholder="Add email" value={v}
          onChange={(e) => { setV(e.target.value); setErr(''); }} style={field} />
        <button className="nb" type="submit" data-testid="cand-email-save" disabled={busy || !v.trim()} style={btn(busy || !v.trim())}>{busy ? 'Saving…' : 'Save'}</button>
      </div>
      {err && <span data-testid="cand-email-error" role="alert" style={{ fontSize: 12, color: '#b91c1c' }}>{err}</span>}
    </form>
  );
}
